// The Vue build version to load with the `import` command
// (runtime-only or standalone) has been set in webpack.base.conf with an alias.
import Vue from 'vue'
import debug from 'debug'
import App from './App'
import { store } from './store/store'
import router from './router'
import Notifications from 'vue-notification'

import ajax  from './libs/ajax'
Vue.config.productionTip = false

var vdebug = debug("esma:main")

if (localStorage.devMode == 1){
  localStorage.debug = 'esma:*';
}else{
  localStorage.debug = 'esma:disabled';
  localStorage.devMode  = 0;
  localStorage.forceHideMessages = 0;
}
if (localStorage.devMode2 != 1){
  localStorage.devMode2  = 0;
}

vdebug("Starting app")

// Styles
import '../node_modules/bootstrap/less/bootstrap.less';
import "../node_modules/ag-grid/dist/styles/ag-grid.css";
import "../node_modules/ag-grid/dist/styles/theme-blue.css";
import "../node_modules/ag-grid/dist/styles/theme-bootstrap.css";

import appHeader from '@/components/header'
import VueLocalStorage from 'vue-localstorage'

Vue.use(VueLocalStorage)
Vue.component("app-header", appHeader)
Vue.use(Notifications)

import barcodeInput from '@/components/barcode-input'
Vue.component("barcode-input", barcodeInput)

// import mixin_login from '@/mixins/mixin_login'

/* eslint-disable no-new */

Vue.prototype.$debug = debug;
Vue.prototype.$ajax = ajax;

var last_version = false
// Vue.prototype.$get_title = (prefix="") =>{
//   if(prefix.length > 0){
//     prefix = prefix + " - "
//   }
//   if(last_version == false){
//     ajax.get_version((data)=>{
//       last_version = data;
//       Vue.prototype.$title = "e-sma (license) - " + last_version;
//         window.document.title = prefix + "e-sma (license) - " + last_version
//     })
//   }else{
//     window.document.title = prefix + "e-sma (license) - " + last_version
//   }
// }
// Vue.prototype.$get_title("");

new Vue({
  el: '#app',
  // mixins:[mixin_login],
  store,
  router,
  template: '<App/>',
  components: { App }
})



// WEBPACK FOOTER //
// ./src/main.js